<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="600px"
    :title="bindWxTit"
    class="qrcode-dialog"
    :mask-closable="false"
    :footer="null"
    @cancel="cancelHandler"
  >
    <div class="qrcode-d-box">
      <div class="qrcode-img">
        <img
          :src="url"
        >
      </div>
      <div class="qrcode-tip">
        <p>
          <template v-if="isEnglish">
            Use personal WeChat scan code to focus on completing the binding
          </template>
          <template v-else>
            1.{{ $t('message["954"]') }}<br>
            2.{{ $t('message["955"]') }}
          </template>
        </p>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getLang } from '@/lib/storage'
// import QrcodeVue from 'qrcode.vue'
export default {
  components: {
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
    // userid: {
    //   type: Number,
    //   default: 0
    // }
  },
  data () {
    return {
      TipDialogVisible: false,
      size: 280

    }
  },
  computed: {
    ...mapState('account/modify', ['userid']),
    bindWxTit () {
      return this.$t('message["1382"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['mergeUser']),
    getLang,
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    cancelHandler () {
      this.TipDialogVisible = false
      setTimeout(() => {
        location.reload()
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode-d-box {
  width: 420px;
  border: 1px solid #ebebeb;
  margin: 0 auto;
  .qrcode-img {
    width: 280px;
    height: 280px;
    margin: 16px auto;
    img {
      width: 280px;
      height: 280px;
    }
  }
  .qrcode-tip {
    border-top: 1px solid #ebebeb;
    p {
      line-height: 24px;
      padding:16px 0 16px 22px;
    }
  }
}
</style>
<style lang="scss">
  .qrcode-dialog {
  .ant-modal-header {
    border-bottom: 0 none;
    text-align: center;
    padding: 28px 21px 0
  }
  .ant-modal-close {
    top: 8px;
  }
}
</style>
